/* eslint-disable no-unused-vars */
import { orderByGraphSequenceNum } from 'monthlyview/component/MonthlyGraphRect'
import React from 'react'

const DailyGraphRect = ({
  data,
  xScale,
  limit,
  yScale,
  margin,
  days,
  height,
  selectedEventNum,
  traslateWidth = 2,
}) => {
  // const [eventNum, setEventNum] = useState(selectedEventNum)

  const filterShadecolor = data.filter(d => parseInt(d.red) === -1)
  const originaldata = data.filter(d => parseInt(d.red) !== -1)

  return (
    <g>
      {/* <rect
        x={xScale(0)}
        y={yScale(100)}
        height={yScale(0) - yScale(100)}
        // width={xScale(parseFloat(days.toFixed(2))) - xScale(0)}
        width={xScale(parseFloat(days.toFixed(2))) - xScale(0)}
        style={{ fill: 'lawngreen' }}
        // onContextMenu={_ => {
        //   setEventNum(-1)
        // }}
      /> */}
      {/* R.reverse(data).map */}
      {orderByGraphSequenceNum(filterShadecolor).map((d, idx) => (
        <rect
          key={idx}
          fill="url(#ReflectGradient)"
          // stroke="black"
          // strokeWidth="2"
          x={xScale(parseFloat(d.startDay)) + traslateWidth}
          y={yScale(100) + margin}
          height={
            yScale(d.endPct) - yScale(d.startPct)
            // height -
            // yScale(
            //   parseFloat(d.endPct) === 0
            //     ? limit
            //     : limit - parseFloat(((limit * d.endPct) / 100).toFixed(2))
            // ) - margin
          }
          width={xScale(parseFloat(d.endDay)) - xScale(parseFloat(d.startDay))}
        />
      ))}
      {orderByGraphSequenceNum(originaldata).map((d, idx) => (
        <rect
          key={idx}
          // startday={d.startDay}
          // startPct={d.startPct}
          endPctValue={d.endPct}
          startPctValue={d.startPct}
          endPct={yScale(d.endPct)}
          startPct={yScale(d.startPct)}
          height2={d => yScale(d.endPct)}
          // limit={limit}
          // margin={margin}
          // startendscal={xScale(d.endDay)}
          // endday={d.endDay}
          // endscal={yScale(limit)}
          x={xScale(parseFloat(d.startDay)) + traslateWidth}
          y={yScale(100) + margin}
          height={
            yScale(d.endPct) - yScale(d.startPct)
            // height -
            // yScale(
            //   parseFloat(d.endPct) === 0
            //     ? limit
            //     : limit - parseFloat(((limit * d.endPct) / 100).toFixed(2))
            // ) - margin
          }
          width={xScale(parseFloat(d.endDay)) - xScale(parseFloat(d.startDay))}
          eventNum={d.eventNum}
          // eslint-disable-next-line no-unused-vars
          //   onClick={e => {
          //     setMonthlyGraphRectSelection({ eventNum: d.eventNum })
          //     setEventNum(d.eventNum + '')
          //   }}
          style={{
            fill: `rgb(${d.red},${d.green},${d.blue})`,
            // stroke: selectedEventNum === d.eventNum ? 'black' : undefined,
          }}
          //   onContextMenu={e => {
          //     setEventNum(e.target.getAttributeNS(null, 'eventNum'))
          //     setMonthlyGraphRectSelection({ eventNum: d.eventNum })
          //   }}
        />
      ))}
    </g>
  )
}

export default DailyGraphRect
